import anime from 'animejs/lib/anime.es.js';

export const fusionReveal = () => {
    let revealAnimOpts = {
        duration: function (t, i) {
            return 800 + i * 100;
        },
        easing: 'easeOutExpo',
        delay: function (t, i) {
            return i * 100;
        },
        opacity: [0, 1],
        translateY: [-100, 0]
    };

    revealAnimOpts.targets = [].slice.call(document.querySelectorAll('.fusion-reveal'));
    anime(revealAnimOpts);
}